import { render, staticRenderFns } from "./joinModal.vue?vue&type=template&id=847c91f8"
import script from "./joinModal.vue?vue&type=script&lang=js"
export * from "./joinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports